<template>
  <div class="entity-form">
    <v-container
      id="fcreate"
      fluid
    >
      <breadcrumbs />
      <h1 class="mb-2">
        Редактирование промокода
      </h1>

      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row>
          <v-col
            cols="12"
            md="7"
          >
            <v-card>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <!-- Название -->
                    <v-col cols="12">
                      <v-text-field
                        v-model="data.name"
                        label="Название"
                        outlined
                        required
                        :rules="rules.required"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Описание -->
                    <v-col cols="12">
                      <v-textarea
                        v-model="data.description"
                        :counter="300"
                        label="Описание"
                        outlined
                        :rules="rules.description"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Код -->
                    <v-col cols="12">
                      <v-text-field
                        v-model="data.code"
                        label="Код"
                        outlined
                        required
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Тип -->
                    <v-col cols="12">
                      <v-select
                        v-model="data.type"
                        label="Тип"
                        :items="[
                          { name: 'Для всех', val: 'all' },
                          { name: 'Персональная скидка', val: 'personal' },
                        ]"
                        item-text="name"
                        item-value="val"
                        outlined
                        required
                        :rules="rules.required"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Действие -->
                    <v-col cols="12">
                      <v-select
                        v-model="data.action"
                        label="Действие"
                        :items="[
                          { name: 'Блюдо в подарок', val: 'dishGift' },
                          { name: 'Удвоение заказа', val: 'doubling' },
                          { name: 'Удвоение 2.0', val: 'doubling_marked' },
                          { name: 'Скидка в рублях', val: 'subtract' },
                          { name: 'Скидка в процентах', val: 'percent' },
                          { name: 'День рождения', val: 'birthDay' },
                        ]"
                        item-text="name"
                        item-value="val"
                        outlined
                        required
                        :rules="rules.required"
                        :loading="loading"
                        :disabled="loading"
                        @change="resetActionSettings"
                      />
                    </v-col>
                    <!-- Процент скидки -->
                    <v-col
                      v-if="['percent', 'birthDay'].includes(data.action)"
                      cols="12"
                    >
                      <v-text-field
                        v-model="data.salePercent"
                        label="Процент скидки"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Сумма скидки -->
                    <v-col
                      v-if="data.action === 'subtract'"
                      cols="12"
                    >
                      <v-text-field
                        v-model="data.saleSubtraction"
                        label="Сумма скидки"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Товар по акции -->
                    <v-col
                      v-if="data.action === 'dishGift'"
                      cols="12"
                    >
                      <v-autocomplete
                        v-model="menuItem"
                        :items="getMenuItems"
                        item-text="name"
                        item-value="id"
                        label="Товар по акции"
                        outlined
                        required
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Модификация товара по акции -->
                    <v-col
                      v-if="data.action === 'dishGift'"
                      cols="12"
                    >
                      <span>{{ menuItemModificationId }}</span>
                      <v-autocomplete
                        v-model="menuItemModificationId"
                        :items="getChangedMenuItemModifications"
                        item-text="modification.name"
                        item-value="id"
                        label="Модификация товара по акции"
                        outlined
                        clearable
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <!--            <v-col cols="12">
                      <div class="block-title">
                        <h3>Ограничения</h3>
                      </div>
                    </v-col>-->
                    <v-col cols="12">
                      <regions-select-fields
                        v-model="data.regions"
                        label="Доступно в регионах"
                        empty-text="Доступно во всех регионах"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <v-col cols="12">
                      <regions-select-fields
                        v-model="data.regionsExclude"
                        label="Не доступно в регионах"
                        empty-text="Нет исключенных регионов"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <v-col cols="12">
                      <categories-select-fields
                        v-model="data.allowedCategories"
                        label="Доступно для блюд из категорий"
                        empty-text="Для всех категорий"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <v-col cols="12">
                      <menu-items-select-fields
                        v-model="data.allowedMenuItems"
                        label="Доступно для отдельных блюд"
                        empty-text="Для всех блюд"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <!-- Дата начала -->
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="8">
                          <!-- ДАТА -->
                          <v-menu
                            v-model="timeOn.menu"
                            :close-on-content-click="false"
                            max-width="290"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="computedTimeOnDateFormattedMomentjs"
                                clearable
                                label="Дата начала"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="timeOn.date = null"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="timeOn.date"
                              @change="timeOn.menu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <!-- ВРЕМЯ -->
                        <v-col cols="4">
                          <v-menu
                            ref="menuTimeOnTime"
                            v-model="timeOn.menuTime"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            return-value.sync="time"
                            transition="scale-transition"
                            offset-y
                            max-width="290"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="timeOn.time"
                                clearable
                                label="Время начала"
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="timeOn.time = null"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="timeOn.menuTime"
                              v-model="timeOn.time"
                              format="24hr"
                              @click:minute="$refs.menuTimeOnTime.save(timeOn.menuTime)"
                            ></v-time-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-col>
                    <!-- Дата конца -->
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="8">
                          <!-- ДАТА -->
                          <v-menu
                            v-model="timeEnd.menu"
                            :close-on-content-click="false"
                            max-width="290"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="computedTimeEndDateFormattedMomentjs"
                                clearable
                                label="Дата конца"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="timeEnd.date = null"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="timeEnd.date"
                              @change="timeEnd.menu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <!-- ВРЕМЯ -->
                        <v-col cols="4">
                          <v-menu
                            ref="menuTimeEndTime"
                            v-model="timeEnd.menuTime"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            return-value.sync="time"
                            transition="scale-transition"
                            offset-y
                            max-width="290"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="timeEnd.time"
                                clearable
                                label="Время начала"
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="timeEnd.time = null"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="timeEnd.menuTime"
                              v-model="timeEnd.time"
                              format="24hr"
                              @click:minute="$refs.menuTimeEndTime.save(timeEnd.menuTime)"
                            ></v-time-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                        >
                          <enum-value-select-field
                            v-model="data.dayOfWeekBegin"
                            label="Доступен с (день недели, включительно)"
                            :enum-class="getDayOfWeekEnumClass()"
                            :loading="loading"
                            :disabled="loading"
                          />
                        </v-col>

                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                        >
                          <enum-value-select-field
                            v-model="data.dayOfWeekEnd"
                            label="Доступен до (день недели, включительно)"
                            :enum-class="getDayOfWeekEnumClass()"
                            :loading="loading"
                            :disabled="loading"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                        >
                          <time-picker-field
                            v-model="data.timeAvailableFrom"
                            label="Доступен с (ч:м)"
                            :loading="loading"
                            :disabled="loading"
                          />
                        </v-col>
                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                        >
                          <time-picker-field
                            v-model="data.timeAvailableTo"
                            label="Доступен до (ч:м)"
                            :loading="loading"
                            :disabled="loading"
                          />
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- Минимальная сумма заказа -->
                    <v-col cols="12">
                      <v-text-field
                        v-model="data.minTotalPriceRub"
                        label="Минимальная сумма заказа, руб."
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="data.minTotalPriceSelfRub"
                        label="Минимальная сумма заказа для самовывоза, руб."
                        outlined
                        :loading="loading"
                        :disabled="loading"
                        hint="Если не заполнена, то берется число из поля выше"
                      />
                    </v-col>
                    <v-col cols="12">
                      <enum-value-select-field
                        v-model="data.deliveryType"
                        label="Доступен только для следующего метода доставки"
                        :enum-class="getPromocodeDeliveryClassEnum()"
                        :loading="loading"
                        :disabled="loading"
                        hint="Если не заполнено, доступен для любого"
                      />
                    </v-col>
                    <v-col cols="12">
                      <enum-value-multi-select-field
                        v-model="data.allowedClientDeviceTypes"
                        label="Доступен для источников заказа"
                        :enum-class="getClientDeviceTypeClassEnum()"
                        :loading="loading"
                        :disabled="loading"
                        empty-text="Если не заполнено, доступен для любого"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="data.onlyFirstOrderOfDeviceTypes"
                        label="Только на первый заказ из выбранных источников"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <!-- Только для новых покупателей -->
                    <v-col cols="12">
                      <v-checkbox
                        v-model="data.onlyFirstOrder"
                        label="Только для новых покупателей"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="data.repeat"
                        label="Разрешить повторное применение промокода клиентом"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="data.onlyCrm"
                        label="Разрешить применять только из CRM"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Показывать в меню -->
                    <v-col
                      v-show="false"
                      cols="12"
                    >
                      <v-checkbox
                        v-model="data.showMenu"
                        label="Показывать в меню"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="data.status"
                        label="Промокод активен"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Сортировка -->
                    <v-col cols="12">
                      <v-text-field
                        v-model="data.sortOrder"
                        label="Сортировка"
                        outlined
                        required
                        :rules="rules.requiredNumber"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Сохранить -->
                    <v-col cols="12">
                      <v-row>
                        <v-col md="4">
                          <v-btn
                            block
                            class="mb-2"
                            color="success"
                            large
                            :loading="loadingForm"
                            :disabled="loadingForm"
                            @click.prevent="save"
                          >
                            Сохранить
                          </v-btn>
                        </v-col>
                        <v-col md="4">
                          <v-btn
                            block
                            class="mb-2"
                            color="success"
                            large
                            :loading="loadingForm"
                            :disabled="loadingForm"
                            @click.prevent="save(false)"
                          >
                            Применить
                          </v-btn>
                        </v-col>
                        <v-col md="4">
                          <v-btn
                            block
                            large
                            color="primary"
                            :loading="loadingForm"
                            :disabled="loadingForm"
                            @click.prevent="$router.push('/promocodes')"
                          >
                            Отмена
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>

      <v-snackbar v-model="snackbar">
        Исправьте ошибки и повторите попытку
        <template v-slot:action="{ attrs }">
          <v-btn
            color="red"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Закрыть
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar v-model="snackbarSuccess">
        Измемнения сохранены
        <template v-slot:action="{ attrs }">
          <v-btn
            color="red"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Закрыть
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'
  import rules from '@/mixins/rules'
  import RegionsSelectFields from '@/components/ui/crud/fields/RegionsSelectField.vue'
  import TimePickerField from '@/components/ui/crud/fields/TimePickerField.vue'
  import DayOfWeek from '@/models/enums/DayOfWeek'
  import EnumValueSelectField from '@/components/ui/crud/fields/EnumValueSelectField.vue'
  import DeliveryType from '@/models/enums/DeliveryType'
  import CategoriesSelectFields from '@/components/ui/crud/fields/CategoriesSelectField.vue'
  import MenuItemsSelectFields from '@/components/ui/crud/fields/MenuItemsSelectField.vue'
  import EnumValueMultiSelectField from '@/components/ui/crud/fields/EnumValueMultiSelectField.vue'
  import ClientDeviceType from '@/models/enums/ClientDeviceType'

  export default {
    components: { EnumValueMultiSelectField, MenuItemsSelectFields, CategoriesSelectFields, EnumValueSelectField, TimePickerField, RegionsSelectFields },
    mixins: [rules],
    data () {
      return {
        data: {},
        timeOn: {
          menu: false,
          menuTime: false,
          date: '',
          time: '',
        },
        timeEnd: {
          menu: false,
          menuTime: false,
          date: '',
          time: '',
        },
        menuItem: null,
        menuItemModificationId: null,
        valid: false,
        loading: false,
        loadingForm: false,
        snackbar: false,
        snackbarSuccess: false,
      }
    },
    computed: {
      ...mapState('promocodes', ['orders']),
      ...mapGetters({
        getMenuItems: 'menuItems/getMenuItemsList',
      }),
      getId () { return this.$route.params.id },
      computedTimeOnDateFormattedMomentjs () {
        return this.timeOn.date ? moment(this.timeOn.date).format('YYYY-MM-DD') : ''
      },
      computedTimeEndDateFormattedMomentjs () {
        return this.timeEnd.date ? moment(this.timeEnd.date).format('YYYY-MM-DD') : ''
      },
      getChangedMenuItemModifications () {
        let modifications = []
        if (this.menuItem) {
          const menuItems = this.getMenuItems.find(v => v.id === this.menuItem)
          if (menuItems) {
            modifications = menuItems.modifications
          }
        }
        return modifications
      },
    },
    async created () {
      try {
        const res = await this.$store.dispatch('promocodes/fetchSinglePromocodes', this.getId)

        this.data = res.data.data
        this.data.regions = res.data.data.regions.map(item => item.id)
        this.data.regionsExclude = res.data.data.regionsExclude.map(item => item.id)
        this.data.allowedCategories = res.data.data.allowedCategories.map(item => item.id)
        this.data.allowedMenuItems = res.data.data.allowedMenuItems.map(item => item.id)

        const timeOn = res.data.data.timeOn
        const timeEnd = res.data.data.timeEnd

        this.timeOn.date = timeOn ? moment.unix(timeOn).format('YYYY-MM-DD') : ''
        this.timeOn.time = timeOn ? moment.unix(timeOn).format('HH:mm') : ''
        this.timeEnd.date = timeEnd ? moment.unix(timeEnd).format('YYYY-MM-DD') : ''
        this.timeEnd.time = timeEnd ? moment.unix(timeEnd).format('HH:mm') : ''
        this.menuItem = res.data.data.saleMenuItem
          ? res.data.data.saleMenuItem.id
          : null
        this.menuItemModificationId = res.data.data.saleModificationMenuItem
          ? res.data.data.saleModificationMenuItem.id
          : null
      } catch (err) { console.error(err) }

      try {
        await this.$store.dispatch('menuItems/fetchMenuItemsList', {
          limit: 10000,
          offset: 0,
          page: 0,
        })
      } catch (err) { console.error(err) }
    },
    methods: {
      getDayOfWeekEnumClass () {
        return DayOfWeek
      },
      getPromocodeDeliveryClassEnum () {
        return DeliveryType
      },
      getClientDeviceTypeClassEnum () {
        return ClientDeviceType
      },
      async save (redirect = true) {
        const validate = this.$refs.form.validate()

        if (validate) {
          this.loadingForm = true

          try {
            const data = this.data

            /**
             * Меняем дату время на UNIXTIME
             */
            const timeOn = `${ this.timeOn.date }T${ this.timeOn.time }`
            const timeEnd = `${ this.timeEnd.date }T${ this.timeEnd.time }`
            data.time_on = moment(timeOn).unix()
            data.time_end = moment(timeEnd).unix()

            data.saleMenuItemId = this.menuItem
            data.saleModificationMenuItemId = this.menuItemModificationId || null

            switch (data.action) {
              case 'dishGift' || 'doubling':
                data.salePercent = null
                data.saleSubtraction = null
                break
              case 'subtract':
                data.salePercent = null
                break
              case 'percent':
                data.saleSubtraction = null
                break
              default:
                break
            }

            const res = await this.$store.dispatch('promocodes/editPromocodes', { data: data, id: this.getId })
            if (res.status === 200 && redirect) {
              this.$router.push('/promocodes')
            } else {
              this.snackbarSuccess = true
              setTimeout(() => {
                this.snackbarSuccess = false
              }, 3000)
            }
          } catch (e) { console.log(e) }
          this.loadingForm = false
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
      resetActionSettings () {
        this.data.salePercent = null
        this.data.saleSubtraction = null
      },
    },
  }
</script>
<style lang="less" scoped>
.block-title {
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(155, 155, 155, 0.99);
}
</style>
